import Page, {
    getServerSideProps as compGetServerSideProps,
} from 'components/pages/Regulations';

export const getServerSideProps = compGetServerSideProps;
export default Page;
